import Heading from "../Components/Heading/Heading";
import LiContent from "../Components/LiContent/LiContent";
import Line from "../Components/Line/Line";
import RelatedT from "../Components/RelatedArticles/Related";
import ConvertButton from "../Components/ConvertButton";
import React from "react";
import FAQComponent from "../Components/FAQComponent/FAQComponent";

function Facebook(){
    const related = [
        {
            href: '/facebook',
            name: 'Facebook',
            side: 'partial support',
            text: 'Facebook is by far the most-known social network. Learn how to use JXL images within Facebook.'
        },
        {
            href: '/the-lounge',
            name: 'The Lounge',
            side: 'no support',
            text: 'The Lounge is a modern web-based IRC client. Learn how to use JXL images within The Lounge.'
        }
    ]
    return(
        <>
            <Heading h='Facebook JPEG XL support' p='#tutorials'/>
            <article>
                <nav className='content_table'>
                    <h4>Table of Content</h4>
                    <ol className='content_ol'>
                        <LiContent n='1' a='#what-is-facebook' text='What is Facebook?'/>
                        <LiContent n='2' a='#facebook-jxl-support' text='Facebook JXL support'/>
                        <LiContent n='3' a='#facebook-likes-jpeg-xl' text='Facebook likes JPEG XL'/>
                    </ol>
                </nav>
                <br/>
                <Line/>

                <span id='what-is-facebook'>
                    <h1 className="main">What is Facebook?</h1>
                    <p className='umain'>Those who sign up for a free Facebook account can connect online with friends, co-workers, or even strangers. You may share pictures, music, videos, articles, and opinions with many individuals. Once the two profiles are linked, both users will view the other user's posts. Facebook users can post anything to their "timelines", which provide a snapshot of what is happening at any given moment. In addition, Facebook users can chat privately with other Facebook users. Users may provide information about themselves in their profiles. A variety of information is posted by users, including employment information, study location, age, and other personal information. Friends and the general public can easily access this information. In addition, users can "like" other pages that interest them.</p>
                </span>
                <Line/>

                <span id='facebook-jxl-support'>
                    <h1 className="main">Facebook JXL support</h1>
                    <p className='umain'>At present, Facebook does sometimes support JPEG XL. During our testing in the last weeks, JPEG XL images have sometimes been accepted and sometimes refused.</p>
                    <p className='umain'>Jon Sneyers said on Twitter that the last time he checked, only worked for jxl files using the container, e.g. recompressed jpegs or files encoded with cjxl --container. During our latest testing on the 8th of November 2021, all JPEG XL files were accepted.</p>
                    <p className='umain'>It might be that Facebook is running tests and therefore support status changes. At the time of writing, Facebook offers full JPEG XL support.</p>
                </span>
                <Line/>

                <span id='facebook-likes-jpeg-xl'>
                    <h1 className="main">Facebook likes JPEG XL</h1>
                    <p className='umain'>Several sources indicate that Facebook is highly excited about the potential of this format. Following the implementation of decoding on browsers by default, it is anticipated that they will start experimenting with serving JPEG XL images to desktop users. As soon as support for JPEG XL becomes available, they plan to test the format in their native iOS and Android applications.</p>
                    <p className='umain'>Having spent the last five months evaluating JPEG XL from a performance and quality perspective, they are confident that it has tremendous potential for the new generation of image formats attempting to succeed JPEG. The results of the tests indicate that JPEG XL is the best image format compared to AVIF and WebP2. Having browser support from all the major browsers will significantly simplify their lives in upcoming experiments and allow them to deliver a consistent experience across platforms and browsers.</p>
                    <p className='umain'>They list the following significant advantages for favoring JPEG XL:</p>
                    <p className='umain'>&#10004; smaller file size and higher quality</p>
                    <p className='umain'>&#10004; fast encoding speed, practical to encode images on the fly</p>
                    <p className='umain'>&#10004; fast decoding speed, surpassing the performance of other formats</p>
                    <p className='umain'>&#10004; support for progressive decoding, offering gains in perceived image load performance</p>
                </span>
                <Line/>
                <br/><FAQComponent/><br/>

                <RelatedT related={related}/>
            </article>


            <ConvertButton/>
            <br/>
        </>
    )
}

export default Facebook